<template>
  <div class="login-box">
    <el-form :model="registerForm" :rules="registerRules" class="login-form">
      <h3 class="title"> {{unitName}} 产 权 竞 价 系 统</h3>
      <el-form-item prop="name">
        <el-input v-model="registerForm.name" autocomplete="off" placeholder="请输入真实姓名" prefix-icon="el-icon-user-solid">
        </el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input v-model="registerForm.phone" autocomplete="off" placeholder="请输入用户手机号" @blur="judgePhone()"
          prefix-icon="el-icon-mobile-phone">
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input :type="textType" v-model="registerForm.password" @blur="judgePhone()" autocomplete="off"
          placeholder="请输入密码" prefix-icon="el-icon-lock">
          <i slot="suffix" class="el-input__icon el-icon-view btn-eye" @click="changeType"></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input :type="textType" v-model="passwordRepeat" autocomplete="off" placeholder="请再次输入密码"
          prefix-icon="el-icon-lock">
          <i slot="suffix" class="el-input__icon el-icon-view btn-eye" @click="changeType"></i>
        </el-input>
      </el-form-item>

      <el-form-item label="验证码" prop="verifyCode">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-input v-model="registerForm.verifyCode" placeholder="验证码" prefix-icon="el-icon-position"
              style="width: 160px">
            </el-input>
          </el-col>
          <el-col :span="9" class="login-captcha">
            <!-- <img :src="captchaPath" @click="getCaptcha()" alt=""> -->
            <!-- <img width="160px" onclick="this.src='http://123.60.208.52:8398/sys/login/captcha?uuid='+new Date()*1" :src="'http://123.60.208.52:8398/sys/login/captcha?uuid=' + this.registerForm.uuid"/> -->
            <img width="100px" height="38px" @click="getCaptcha()" :src="
      	  'http://36.133.43.44:8547/api/web/captcha?uuid=' +
      	  this.registerForm.uuid
      	" />
            <!--http://platform.jtsmart.net:8547/-->
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="register()" :disabled="!phoneFlag" class="login-btn">确 认 注 册</el-button>
        <router-link to="/login">
          <el-button style="margin-top: -10px;" type="success" class="login-btn">登 录</el-button>
        </router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        registerForm: {
          phone: "",
          password: "",
          verifyCode: "",
          uuid: "",
          unitCode: localStorage.getItem("unitCode"),
          name: "",

        },
        unitName: localStorage.getItem("unitName"),

        textType: 'password',
        phoneFlag: true,
        captchaPath: "",
        passwordRepeat: "",
        registerRules: {
      			 phone: [{
              required: true,
              message: "请输入用户名",
     	        trigger: "blur"
            },
            {
              min: 3,
              max: 16,
              message: "长度在 3 到 10 个字符",
              trigger: "blur",
            },
          ],
          password: [{
              required: true,
              message: "请输入密码",
              trigger: "blur"
            },
            {
     	        min: 3,
              max: 16,
              message: "长度在 3 到 16 个字符",
              trigger: "blur",
            },
          ],
          verifyCode: [{
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }, ],
        },
      };
    },
    created() {
      sessionStorage.clear();
      this.getCaptcha();
    },
    methods: {
      async judgePhone() {
        if (this.registerForm.phone == "") {
          return;
        }
        const {
          data: res
        } = await this.$http.get("/web/verifyIsExist/" + this.registerForm.phone);
        if (res.flag) {
          this.$message.error("该手机号已注册，请输入新的手机号或登录！");
          this.phoneFlag = false;
        }
        else{
           this.phoneFlag=true;
        }

      },
      // 登录
      register() {
        if (this.registerForm.name == "") {
          this.$message.error("请输入真实姓名");
          return;
        }
        if (this.registerForm.phone.length != 11) {
          this.$message.error("请输入正确格式的手机号");
          return;
        }
        if (this.registerForm.password != this.passwordRepeat) {
          this.$message.error("两次输入的密码不一致");
          return;
        }
        if (this.registerForm.password.length < 6) {
          this.$message.error("您输入的密码必须大于6位");
          return;
        }

        this.$http.post("/web/register", this.registerForm).then((res) => {
          if (res.data.msg = "success") {
            this.$message.success("注册成功，请登录")
            this.$router.push("/login");
          }
        });



      },
      async getCaptcha() {
        this.registerForm.uuid = Date.parse(new Date()) + Math.ceil(Math.random() * 100);;
        console.log(this.registerForm.uuid);
      },
      changeType() {
        this.textType = (this.textType === 'password' ? 'text' : 'password')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #20222A;
    background-image: url(../assets/bg.png);
    background-size: cover;

    .login-form {
      border-radius: 5px;
      background-clip: padding-box;
      margin: 40px auto;
      width: 350px;
      padding: 35px 35px 15px 35px;
      background: #f5f5f5;
      border: 1px solid #eaeaea;
      box-shadow: 0 0 5px #cac6c6;

      .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
      }

      .btn-eye {
        cursor: pointer;
      }

      .text-danger {
        color: #F56C6C;
      }

      .login-btn {
        margin: 35px 0 10px 0;
        width: 100%;
      }
    }
  }
</style>
